import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { withRouter } from "react-router";
import axios from "../components/Axios";

import NavBar from "../components/NavBar";
import "./Invoice.css";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            lines: [],
            amount: 0,
            created: 0,
            id: '',
        };
    }

    componentDidMount() {
        this.getItem();
    }

    async getItem() {
        this.setState({ loading: true });

        if (this.props.match.params.id.startsWith('in_')) {
            let resp = await axios.get('/user/stripe/invoice/' + this.props.match.params.id);
            this.setState({ loading: false, lines: resp.data.lines.data, created: resp.data.created, id: resp.data.id });
        } else {
            let resp = await axios.get('/user/stripe/transaction/' + this.props.match.params.id);
            this.setState({ loading: false, amount: resp.data.amount, created: resp.data.created, id: resp.data.id });
        }


    }

    formatDate(u) {
        let d = new Date(u)
        return d.toLocaleString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric"
        });
    }

    addressEdit(e) {
        localStorage.setItem("billing_address", e.currentTarget.innerText);
    }

    render() {
        return (
            <div className="background">
                <Container maxWidth="sm" className="invoicePage">
                    <div className="dateSection">
                        <div className="invoiceLogo">
                            <img src="/android-chrome-512x512.png" />
                        </div>
                        <div>
                            <Typography variant="h2" className="invoiceTitle">Invoice</Typography>
                            <div style={{ paddingLeft: '5px', paddingTop: '16px' }}>
                                <b>DATE:</b> {this.formatDate(this.state.created * 1000)}<br />
                                <b>INVOICE #</b> {this.state.id.slice(3)}
                            </div>
                        </div>
                    </div>
                    <div className="addressSection">
                        <div><b>FROM:</b></div>
                        <div>
                            VideoViews<br />
                            800 rue du Square-Victoria, suite 376<br />
                            Montreal, Quebec<br />
                            H3C 0B4 Canada
                        </div>
                        <div><b>TO:</b></div>
                        <div contentEditable style={{ whiteSpace: 'pre-wrap' }}
                            onBlur={this.addressEdit}>{localStorage.getItem('billing_address')}</div>
                    </div>
                    <table className="invoiceTable">
                        <thead>
                            <tr>
                                <th style={{ textAlign: "left" }}>Item</th>
                                <th>Unit Price</th>
                                <th>Quantity</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.lines.map((item, index) => (
                                <tr hidden={item.amount === 0}>
                                    <td style={{ textAlign: "left" }}>
                                        <span>{item.description}</span><br />
                                        <sub>{this.formatDate(item.period.start * 1000)} to {this.formatDate(item.period.end * 1000)}</sub></td>
                                    <td></td>
                                    <td>{item.quantity === 0 ? '' : item.quantity}</td>
                                    <td><b>{item.amount_excluding_tax / 100} {item.currency.toUpperCase()}</b></td>
                                </tr>
                            ))}
                            <tr hidden={this.state.amount === 0}>
                                <td style={{ textAlign: "left" }}>
                                    <span>VideoViews Credit</span><br />
                                    <sub>1 credit provides A.I Analysis
                                        for 1 hour of video content</sub></td>
                                <td>5</td>
                                <td>{this.state.amount / 500}</td>
                                <td><b>{this.state.amount / 100} USD</b></td>
                            </tr>
                        </tbody>
                    </table>
                </Container>
            </div>
        );
    }
}

export default withRouter(Index);
